import { Component, OnInit, OnDestroy } from '@angular/core';
import { HeaderComponent } from '../header/header.component';
import { Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { CommonModule, NgIf } from '@angular/common'; // ✅ เพิ่มตรงนี้
import { HttpClient } from '@angular/common/http';
import { LanguageService } from '../../../core/services/language.service';
import { HomeTopUpModel } from '../../../core/models/user.model';
import { PssLoadingComponent } from '../../../tools/template/pss/pss-loading/pss-loading.component';
import { PssSuccessComponent } from '../../../tools/template/pss/pss-success/pss-success.component';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, CommonModule, PssLoadingComponent, PssSuccessComponent],
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css'],
})
export class LayoutComponent implements OnInit {
  public currentUrl = '';
  appVersion = '0.0.0';
  currentLang: 'TH' | 'EN' = 'TH';
  private routerSub!: Subscription;
  isHomeActive = false;
  showFooterMain = false;
  isFooterCollapsed = false;

  // State for simulated barrier opening
  isLoadingBarrier = false;
  isSuccessBarrier = false;
  textSuccessBarrier = '';
  detailSuccessBarrier = '';

  homeTopUpData: HomeTopUpModel = {
    vehicleCount: 0,
    evCount: 0,
    amount: 0,
    activateCard: 0,
    notify: 0
  };

  private readonly footerRoutes = [
    '/home',
    '/ev-charger',
    '/parking-center',
    '/profile',
    '/check-amount-parking'
  ];

  constructor(
    private router: Router,
    private http: HttpClient,
    private languageService: LanguageService) {

    this.languageService.currentLang$.subscribe(lang => {
      this.currentLang = lang;
    });

  }

  /**
   * เมธอดเริ่มแรกสำหรับตรวจจับการเปลี่ยนเส้นทาง URL และเช็คสถานะการแสดงผล Footer
   */
  ngOnInit(): void {
    // เช็ค URL ทันที
    this.currentUrl = this.router.url;

    this.routerSub = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.currentUrl = event.urlAfterRedirects;
        this.checkFooterVisibility(this.currentUrl);
      });

    this.checkFooterVisibility(this.currentUrl);

    console.log("🔍 Current path : ", this.currentUrl, this.showFooterMain);
  }

  /**
   * คืนทรัพยากรการเป็นสมาชิกเมื่อคอมโพเนนต์ถูกทำลาย
   */
  ngOnDestroy() {
    if (this.routerSub) {
      this.routerSub.unsubscribe();
    }
  }

  /*#################################################### Function ################################################*/

  /**
   * ตรวจสอบความเหมาะสมในการแสดงผล Footer ตามเส้นทาง URL ปัจจุบัน
   */
  private checkFooterVisibility(url: string): void {
    // ตัด query/fragment ออกก่อนเทียบ เช่น /home?x=1
    const path = (url || '').split('?')[0].split('#')[0];
    const check = this.footerRoutes.some(
      (route) => path === route || path.startsWith(route + '/'),
    );
    this.showFooterMain = check;
    if (check) {
      this.loadHomeTopUp();
    }
  }

  /**
   * ตรวจสอบเวอร์ชันของแอปพลิเคชันล่าสุดจากไฟล์ version.json
   */
  checkAppVersion(): void {
    this.http
      .get<{ version: string }>('/version.json', {
        headers: { 'Cache-Control': 'no-cache' },
      })
      .subscribe((response) => {
        const currentVersion = localStorage.getItem('app_version');
        this.appVersion = currentVersion || '';
      });
  }

  // get showFooterParking_center(): boolean {
  //   const showIn = ['/parking-center']; // 👈 เพิ่มเส้นทางที่คุณไม่อยากให้แสดง footer
  //   return showIn.some((path) => this.currentUrl.startsWith(path));
  // }
  // get showFooterMain(): boolean {
  //   const showIn = ['/home','/ev-charger','/parking-center','/profile'];
  //   return showIn.some((path) => this.currentUrl.startsWith(path));
  // }

  //   get showBackButton(): boolean {
  //   const noBackPages = ['/home', '/dashboard', '/login'];
  //   return !noBackPages.includes(this.currentUrl);
  // }
  // toggleFooter() {
  //   this.isFooterCollapsed = !this.isFooterCollapsed;
  // }

  get isPageWithHeader(): boolean {
    const pagesWithHeader = [
      '/home',
      '/profile',
      '/profile-edit',
      '/address',
      '/pomotion-info',
      '/register-member-vehicle',
      '/top-up-history-ev-charger',
      '/ev-charger-invoice',
      '/ev-charger-history',
      '/ev-charger-detail'
    ];
    return pagesWithHeader.some((path) => this.currentUrl.startsWith(path));
  }

  /**
   * โหลดข้อมูลการเติมเงินและจำนวนแจ้งเตือนจาก session storage
   */
  loadHomeTopUp() {
    setTimeout(() => {
      const data = sessionStorage.getItem('homeTopUp');
      this.homeTopUpData = data ? JSON.parse(data) : this.homeTopUpData;
      console.log('HomeTopUpData session :', this.homeTopUpData);
    }, 800);
  }

  /**
   * จำลองขั้นตอนการส่งคำสั่งเปิดไม้กั้นลอยตรงกลาง
   */
  openBarrier() {
    this.isLoadingBarrier = true;
    setTimeout(() => {
      this.isLoadingBarrier = false;
      this.isSuccessBarrier = true;
      this.textSuccessBarrier = this.currentLang === 'TH' ? 'เปิดไม้กั้นสำเร็จ!' : 'Barrier Opened!';
      this.detailSuccessBarrier = this.currentLang === 'TH' ? 'ขอให้เดินทางโดยสวัสดิภาพ' : 'Have a safe trip!';
    }, 1500);
  }

  /*############################################# API #################################################*/

}
